<template>
  <div class="container py-2">
    <div v-if="!loading">
      <p class="mb-2">Template: {{ templateName }}</p>
      <FormulateForm
        ref="form"
        debounce
        :schema="computedSchema"
        v-model="model"
        @submit="onSubmit"
        @created="onFormReady"
        @failed-validation="onValidate"
        @input="onModelChange"
      />
    </div>
    <div class="text-center" v-else>
      <b-spinner label="Spinning" variant="primary"></b-spinner>
    </div>
  </div>
</template>

<script>
import axios from "@axios";
import FormNormalizer from "./FormNormalizer";
import FileUploadWithPreview from "./FileUploadWithPreview.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    FileUploadWithPreview,
  },
  props: {
    formId: Number | String,
    templateId: Number | String,
    data: Array | Object,
    serviceOrderId: Number | String,
  },
  data() {
    return {
      loading: true,
      templateName: "",
      templateData: [],
      localFormId: null,
      localTemplateId: null,
      localServiceOrderId: null,
      serviceOrder: null,
      schema: [],
      model: {},
      filesData: {},
      formNormalizer: null,
    };
  },
  computed: {
    computedSchema() {
      const hasFormNormalizer = this.formNormalizer !== null;
      const hasTemplateData =
        Array.isArray(this.templateData) && this.templateData.length > 0;

      if (!hasFormNormalizer || !hasTemplateData) {
        return this.schema || [];
      }

      const currentFormAnswers = this.model || {};
      this.formNormalizer.model = currentFormAnswers;

      const generatedSchema = this.formNormalizer.convert();

      this.$nextTick(() => {
        const formComponent = this.$refs.form;
        if (formComponent) {
          formComponent.$forceUpdate();
        }
      });

      return generatedSchema || [];
    },
  },
  created() {
    this.model = this.data;
    this.localFormId = this.formId;
    this.localTemplateId = this.templateId;
    this.localServiceOrderId = this.serviceOrderId;
    this.serviceOrder = null;
  },
  async mounted() {
    console.log("mounted");
    console.log("localServiceOrderId:" + this.localServiceOrderId);
    if (this.localServiceOrderId) {
      this.checkIfFormExists()
        .then(async (resp) => {
          this.serviceOrder = resp.data.service_order;
          this.localFormId = resp.data.id;
          await this.fetchForm();
          this.setFacility();
          this.initializeFormNormalizer(); // Inicializa FormNormalizer aquí
          this.loading = false;
        })
        .catch(async () => {
          const { data } = await this.fetchServiceOrder();
          this.serviceOrder = data.data;
          await this.fetchTemplate();
          this.setFacility();
          this.initializeFormNormalizer(); // Inicializa FormNormalizer aquí
          this.loading = false;
        });
    } else {
      console.log("localFormId:" + this.localFormId);
      if (this.localFormId) {
        await this.fetchForm();
        console.log("initializeFormNormalizer");
        this.initializeFormNormalizer(); // Inicializa FormNormalizer aquí
      } else if (this.templateId) {
        await this.fetchTemplate();
        this.initializeFormNormalizer(); // Inicializa FormNormalizer aquí
      }
      this.loading = false;
    }
  },
  methods: {
    onFormReady() {
      console.log("onFormReady");
      this.$nextTick(() => {
        const validateBtn = document.querySelector("#validate-maintenance-form");
        if (validateBtn) {
          const newBtn = validateBtn.cloneNode(true);
          validateBtn.parentNode.replaceChild(newBtn, validateBtn);
          newBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.$emit("validated", this.serviceOrder ? this.serviceOrder.id : null);
          });
        }
      });
    },
    onValidate() {},
    onModelChange() {
      this.$forceUpdate();
    },
    async checkIfFormExists() {
      return axios.get(
        `/v1/maintenance-forms/get-form-by-service-order/${this.localServiceOrderId}`
      );
    },
    async fetchForm() {
      const { data } = await axios.get(`/v1/maintenance-forms/${this.localFormId}`);
      console.log("fetchForm:" + data.id_template);
      this.localTemplateId = data.id_template;
      this.serviceOrder = data.service_order ? data.service_order : this.serviceOrder;

      await this.fetchTemplate();

      this.model = data.data;
      // Inicializar filesData con archivoso con los archivos que ya existen en el modelo
      this.initializeFilesData();
    },
    async fetchTemplate() {
      const { data } = await axios.get(
        `/v1/maintenance-templates/${this.localTemplateId}`
      );
      const response = data;
      console.log("fetchTemplate:" + JSON.stringify(response.data));
      this.templateName = response.name;
      this.templateData = response.data;
      this.$emit("loaded", true);
    },
    fetchServiceOrder() {
      return axios.get(`/v1/service_orders/${this.localServiceOrderId}`);
    },
    initializeFormNormalizer() {
      console.log(this.serviceOrder.latest_status.status);
      const disableFields = ["finished", "canceled"].includes(
        this.serviceOrder.latest_status.status
      );

      const showValidateButton =
        ["in_review"].includes(this.serviceOrder.latest_status.status) &&
        this.localFormId;

      this.formNormalizer = new FormNormalizer(this, this.templateData, {
        disabled: disableFields,
        showValidateBtn: showValidateButton,
        customComponents: {
          FileUploadWithPreview,
        },
        model: this.model,
        onUpdateFiles: this.handleFileUpload,
      });
      this.schema = this.formNormalizer.convert();
      // Inicializar filesData despues de crear el schema
      this.$nextTick(() => {
        this.initializeFilesData();
      });
    },
    initializeFilesData() {
      // Inicializar filesData con archivos existentes del modelo
      if (!this.model || !this.templateData) return;

      this.templateData.forEach((field) => {
        if (
          (field.type === "media" || field.type === "signature") &&
          this.model[field.name]
        ) {
          const existingFiles = Array.isArray(this.model[field.name])
            ? this.model[field.name]
            : [];

          if (!this.filesData[field.name]) {
            this.$set(this.filesData, field.name, {
              newFiles: [],
              existingFiles: existingFiles,
            });
          } else {
            this.filesData[field.name].existingFiles = existingFiles;
          }
        }
      });
    },
    handleFileUpload({ id, files, label, rawFiles, existingFiles }) {
      console.log("handleFileUpload");
      if (!this.filesData[label]) {
        this.$set(this.filesData, label, {
          newFiles: [],
          existingFiles: [],
        });
      }

      // Guardar archivos nuevos (rawFiles)
      this.filesData[label].newFiles = rawFiles || [];
      // Guardar archivos existentes que quedan después de eliminar algunos
      this.filesData[label].existingFiles = existingFiles || [];
    },
    onSubmit(data) {
      console.log("SubmitButton");
      console.log(data);
      const formData = new FormData();
      formData.append("name", this.templateName || "Maintenance Form");
      formData.append("id_template", this.localTemplateId);
      formData.append("id_service_order", this.localServiceOrderId);

      const finalData = { ...data };

      Object.keys(this.filesData).forEach((label) => {
        const fileInfo = this.filesData[label];

        // Combinar archivos existentes que quedan y archivos nuevos
        const allFiles = [];

        // Agregar archivos existentes que quedan (solo los que tienen URL)
        if (fileInfo.existingFiles && Array.isArray(fileInfo.existingFiles)) {
          fileInfo.existingFiles.forEach((file) => {
            if (file && file.url) {
              allFiles.push({
                url: file.url,
                name: file.name,
              });
            }
          });
        }

        // Agregar archivos nuevos
        if (fileInfo.newFiles && Array.isArray(fileInfo.newFiles)) {
          fileInfo.newFiles.forEach((file) => {
            allFiles.push({
              url: "",
              name: file.name,
            });
            // Agregar el archivo real al FormData
            formData.append(`${label}[]`, file);
          });
        }

        // Solo asignar si hay archivos
        if (allFiles.length > 0) {
          finalData[label] = allFiles;
        } else {
          // Si no hay archivos, asignar array vacío
          finalData[label] = [];
        }
      });

      formData.append("data", JSON.stringify(finalData));

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      if (this.localFormId) {
        axios
          .put(`v1/maintenance-forms/${this.localFormId}`, formData, config)
          .then((resp) => {
            if (resp.status === 200 && this.$toast) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t("messages.edit_save.updated_successfully"),
                  icon: "CheckIcon",
                  variant: "success",
                },
              });
            }
            this.$emit("submit");
          })
          .catch((error) => {
            this.$emit("submitError", { action: "create", error });
            console.log("submitError", { action: "create", error });
          });
      } else {
        axios
          .post("v1/maintenance-forms", formData, config)
          .then((resp) => {
            this.$emit("submit");
          })
          .catch((error) => {
            this.$emit("submitError", { action: "update", error });
            console.log("submitError", { action: "update", error });
          });
      }
    },
    setFacility() {
      const schemaField = this.schema.find((sch) =>
        ["facilities", "hidden"].includes(sch.type)
      );

      if (schemaField) {
        const fieldName = schemaField.name;
        const { unit } = this.serviceOrder;
        const facilityObj = unit.id;

        if (!this.model) this.model = {};
        this.model[fieldName] = facilityObj;
      }
    },
  },
};
</script>

<style>
.preview-container {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.preview-image {
  max-width: 100px;
  max-height: 100px;
  margin-right: 10px;
  cursor: pointer;
}
</style>
